import React, { useEffect, useState } from 'react';
import ApiService from '../services/api';

const ApiTest: React.FC = () => {
  const [health, setHealth] = useState<any>(null);
  const [products, setProducts] = useState<any[]>([]);
  const [merchants, setMerchants] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const runTests = async () => {
    setLoading(true);
    setError(null);
    try {
      const [healthData, productsData, merchantsData] = await Promise.all([
        ApiService.checkHealth(),
        ApiService.getProducts(),
        ApiService.getMerchants(),
      ]);
      setHealth(healthData);
      setProducts(productsData);
      setMerchants(merchantsData);
    } catch (err: any) {
      setError(err.message || 'حدث خطأ غير متوقع');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    runTests();
  }, []);

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">اختبار الاتصال مع الباك اند</h1>
      <button
        className="mb-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        onClick={runTests}
        disabled={loading}
      >
        {loading ? 'جاري التحديث...' : 'إعادة الاختبار'}
      </button>
      {error && <div className="text-red-600 mb-4">خطأ: {error}</div>}
      {!error && (
        <>
          <div className="mb-6">
            <h2 className="text-lg font-semibold mb-2">حالة السيرفر:</h2>
            {health ? (
              <div className={"font-bold " + (health.status === 'ok' ? 'text-green-600' : 'text-red-600')}>
                {health.status === 'ok' ? '✅ السيرفر يعمل بشكل سليم' : '❌ هناك مشكلة في السيرفر'}
              </div>
            ) : (
              <div>جاري جلب حالة السيرفر...</div>
            )}
          </div>
          <div className="mb-6">
            <h2 className="text-lg font-semibold mb-2">عدد المنتجات: {products.length}</h2>
            <ul className="list-disc pr-6 mb-2">
              {products.map((product: any) => (
                <li key={product.id} className="mb-1">
                  {product.extracted_data?.product_name || 'منتج بدون اسم'}
                </li>
              ))}
            </ul>
          </div>
          <div className="mb-6">
            <h2 className="text-lg font-semibold mb-2">عدد التجار: {merchants.length}</h2>
            <ul className="list-disc pr-6">
              {merchants.map((merchant: any) => (
                <li key={merchant.id} className="mb-1">
                  {merchant.name_ar} ({merchant.name_en})
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
};

export default ApiTest;